var _a;
var RewardsClients;
(function (RewardsClients) {
    RewardsClients["athome"] = "athome";
    RewardsClients["hft"] = "hft";
    RewardsClients["tjx"] = "tjx";
    RewardsClients["jcrew"] = "jcrew";
})(RewardsClients || (RewardsClients = {}));
export var CLIENTS_DATA = (_a = {},
    _a[RewardsClients.athome] = {
        certificateValue: 5,
        certificateExpirationDays: 90,
    },
    _a[RewardsClients.hft] = {
        certificateValue: 5,
        certificateExpirationDays: 30,
    },
    _a[RewardsClients.tjx] = {
        certificateValue: 10,
        certificateExpirationDays: 90,
    },
    _a);
export default RewardsClients;
